<template>
  <ModalComponent
    ref="modal"
    iconLeftBg="#00f2"
    :onPrimaryClick="
      () => {
        onFormSubmited()
      }
    "
    :onOverlayClick="
      () => {
        onDismissClick()
      }
    "
    :onCancelClick="
      () => {
        onDismissClick()
      }
    "
    :onBackButtonClick="
      () => {
        onDismissClick()
      }
    "
    :primaryButtonLoading="false"
    :isModal="isModal"
    :isBottomSheet="isBottomSheet"
  >
    <template #titleText>
      <div
        class="max-w-full w-[450px]"
        :class="{ 'px-8': isBottomSheet }"
        :key="'title' + promptId"
      >
        <div v-html="title"></div>
      </div>
    </template>
    <template #subtitleText>
      <div
        class="max-w-full w-[450px]"
        :class="{ 'px-8': isBottomSheet }"
        :key="'subtitle' + promptId"
      >
        <div v-html="subTitle"></div>
      </div>
    </template>

    <div
      class="max-w-full w-full gap-y-4 flex flex-col px-4 pb-6"
      :key="'content' + promptId"
    >
      <div v-for="(option, i) in internalOptions" :key="i">
        <div
          class="ripple p-2 py-4"
          :class="{
            '!py-5 pl-6 rounded-3xl border border-[#adadad]': !hideBorder,
            'border-2 border-[#191b23] ':
              !hideBorder && selectedOption.id == option.id,
          }"
          @click="selectOption(option)"
        >
          <div class="flex gap-3 items-center">
            <div
              class="[&_*]:!duration-500"
              :class="{ 'order-last': radioToEnd }"
              v-if="!hideRadio"
            >
              <div class="w-[1.5rem] h-[1.5rem] relative">
                <div
                  class="rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-[#191b23] w-[0.8rem] h-[0.8rem] bg-[#191b23]':
                      selectedOption.id == option.id,
                    'border-[gray] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedOption.id !== option.id,
                  }"
                ></div>
                <div
                  class="rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-[#191b23] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedOption.id == option.id,
                    'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                      selectedOption.id !== option.id,
                  }"
                ></div>
              </div>
            </div>
            <div class="w-full">
              <div v-html="formatDisplay(option.value)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #primaryButton v-if="successText">
      {{ successText }}
    </template>
    <template #cancelButton v-if="cancelText">
      {{ cancelText }}
    </template>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from './BottomSheetModal.vue'
import Commons from '@/shared/utils/commons'

export default defineComponent({
  name: 'ChoiceModal',
  components: {
    ModalComponent,
  },
  props: {
    init: {
      type: Function,
      default: () => {
        console.log('event for init not set')
      },
    },
  },
  data() {
    return {
      title: 'Title',
      subTitle: '???',
      formClasses: 'Title',
      options: [],
      successText: 'Ok',
      cancelText: 'Retour',
      canDismiss: true,
      selectOnClick: false,
      radioToEnd: false,
      hideRadio: false,
      hideBorder: false,
      isBottomSheet: false,
      isModal: false,
      promptId: '',
      formatDisplay(data) {
        return data
      },
    }
  },
  mounted() {
    this.initPromptFunction()
  },
  methods: {
    initPromptFunction() {
      try {
        window.choicePrompt = this.prompt
      } catch (error) {
        console.log(error)
      }
    },
    async prompt(data) {
      if (this.modalPromptIsVisible()) {
        console.log('end prompt when new request prompt')
        this.endPrompt(false)
        await new Promise(r => setTimeout(r, 500))
      }
      console.log('new prompt')
      this.promptId = `${Date.now()}`
      this.title = data.title || ''
      this.subTitle = data.subTitle || ''
      this.formClasses = data.formClasses || ''
      this.options = data.options || []
      this.successText = data.successText || ''
      this.cancelText = data.cancelText || ''
      this.selectOnClick = !!data.selectOnClick
      this.radioToEnd = !!data.radioToEnd
      this.hideRadio = !!data.hideRadio
      this.isModal = typeof data.isModal == 'boolean' ? data.isModal : false
      this.isBottomSheet =
        typeof data.isBottomSheet == 'boolean' ? data.isBottomSheet : false

      this.formatDisplay =
        data.formatDisplay ||
        function (option) {
          return option
        }
      this.canDismiss = Commons.isEmpty(data.canDismiss)
        ? true
        : !!data.canDismiss
      const promptPromise = new Promise(resolve => {
        this.handleEventEmitted(
          `choicePromptResponse:${this.promptId}`,
          resolve,
        )
      })
      this.selectedOption = {}
      if (data.defaultOption)
        this.selectedOption =
          this.internalOptions.find(option => {
            this.formatDisplay(option.value) ==
              this.formatDisplay(data.defaultOption)
          }) || {}

      await new Promise(r => setTimeout(r, 500))
      this.showModalPrompt()
      return promptPromise
    },
    handleEventEmitted(eventName, callback) {
      document.addEventListener(eventName, event => {
        callback(event.detail)
      })
    },
    dispatchEvent(eventName, data = {}) {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: data,
        }),
      )
    },
    showModalPrompt() {
      this.$refs.modal.show()
    },
    hideModalPrompt() {
      this.$refs.modal.hide(true)
    },
    modalPromptIsVisible() {
      return this.$refs.modal.isVisible()
    },
    onFormSubmited() {
      if (!this.selectedOption) {
        Events.dispatch('toast_notification', {
          type: 'warning',
          title: 'Incomplet',
          body: 'Veuillez sélectionner un élément',
        })
        return
      }
      this.endPrompt(true, this.selectedOption.value || null)
    },
    onDismissClick() {
      if (this.canDismiss) this.endPrompt()
      else {
        this.showModalPrompt()
        console.log('cannot dismiss modal')
      }
    },
    endPrompt(promptAccepted, data = null) {
      this.hideModalPrompt()
      setTimeout(() => {
        this.dispatchEvent(`choicePromptResponse:${this.promptId}`, {
          success: true,
          accepted: promptAccepted,
          data,
        })
        this.promptId = ''
      }, 250)
    },
    selectOption(option) {
      this.selectedOption = option
      if (this.selectOnClick) this.onFormSubmited()
    },
  },
  computed: {
    internalOptions() {
      return (this.options || []).map((option, index) => {
        return {
          id: index,
          value: option,
        }
      })
    },
  },
})
</script>
